import { personGennemfoerteTilsynForm } from "../../../../../config/form/person/personGennemfoerteTilsynFormConfig";
import { getHeaderActiveColumns, TD } from "../../../../../util/table";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import TableBasic, { TableRow } from "../../../../Table/TableBasic";
import IngenRegistreringer from "../IngenRegistreringer";
import { PersonDto, PersonTilsyn } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import { defaultPersonGennemfoerteTilsynColumns } from "../../../../../config/person";
import useLocalStorageState from "use-local-storage-state";
import { useContext } from "react";
import { UserQueryContext } from "../../../../../context/UserContext";
import { orderBy } from "../../../../../util/orderBy";

export default function GennemfoerteTilsyn({
  person,
  personTilsyn,
  invalidateData,
}: {
  person: PersonDto;
  personTilsyn: PersonTilsyn[];
  invalidateData: InvalidateDataFunction<any>;
}) {
  const { user, hasPermission } = useContext(UserQueryContext);
  const isAuth = hasPermission(user, "TilsynWrite");
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personGennemfoerteTilsynSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );
  const [columns, setActiveColumns] = useActiveColumns(
    "person-persongennemfoertetilsyn-active-columns",
    defaultPersonGennemfoerteTilsynColumns,
  );

  // event handlers
  function downloadHandler() {
    tableToXLSX(columns, personTilsyn, {
      fileName: `gennemførtetilsyn-for-${person.kundeNr}`,
      additionalData: {
        kundenr: person.kundeNr,
      },
    });
  }

  if (!personTilsyn.length) {
    return (
      <IngenRegistreringer
        editConfig={
          isAuth
            ? personGennemfoerteTilsynForm(person.id, undefined)
            : undefined
        }
        invalidateData={invalidateData}
      />
    );
  }

  return (
    <>
      <ButtonDownload onClick={downloadHandler} />

      <TableBasic
        editConfig={
          isAuth
            ? personGennemfoerteTilsynForm(person.id, undefined)
            : undefined
        }
        invalidateData={invalidateData}
        defaultColumns={defaultPersonGennemfoerteTilsynColumns}
        columns={columns}
        setActiveColumns={setActiveColumns}
        headerRow={getHeaderActiveColumns(columns, {
          defaultSortBy,
          setSortBy,
          sortBy,
        })}
      >
        {orderBy(
          personTilsyn,
          sortBy.map((s) => s.field),
          sortBy.map((s) => s.direction),
        ).map((tilsyn) => {
          return (
            <TableRow
              key={tilsyn.id}
              editConfig={
                isAuth
                  ? personGennemfoerteTilsynForm(person.id, tilsyn.id)
                  : undefined
              }
              invalidateData={invalidateData}
            >
              {columns
                .filter((col) => col.active)
                .map((col) => {
                  return <TD key={col.field} col={col} rowData={tilsyn} />;
                })}
            </TableRow>
          );
        })}
      </TableBasic>
    </>
  );
}

const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "gennemfoerselDato",
  },
];
